module.exports = "../../static/img/ow.8a22e0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ow.png
// module id = 917
// module chunks = 1